/**
 * @module Composition
 */
/**
 * (B -> C) . (A -> B) = A -> C
 */
export default function compose(f, g, ...maybeArgs) {
    return maybeArgs.length === 0
        ? (...args) => f(g(...args))
        : f(g(...maybeArgs));
}
